document.addEventListener("DOMContentLoaded", function() {
    const writeReviewBtn = document.getElementById("write-review");
    const formContainer = document.getElementById("review-form-container");
    const closeReviewBtn = document.getElementById("close-review");
    const reviewForm = document.getElementById("review-form");

    if (writeReviewBtn && formContainer) {
        writeReviewBtn.addEventListener("click", function() {
            formContainer.style.display = "flex";
        });
    }

    if (closeReviewBtn && formContainer) {
        closeReviewBtn.addEventListener("click", function() {
            formContainer.style.display = "none";
        });
    }

    if (reviewForm) {
        reviewForm.addEventListener("submit", function(event) {
            event.preventDefault();

            alert("Review submitted!");
            formContainer.style.display = "none";
        });
    }
});